const STYLE_ID = 'tour-transition-styles';

// Add global CSS to control popover visibility during element preparation only
export function ensureTourStyles() {
  if (document.getElementById(STYLE_ID)) return;

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
        /* Hide popover only during initial element preparation (first step) */
        body.tour-initializing .driver-popover {
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }

        /* Temporarily hide during transitions between steps - hide popover and highlight only */
        body.tour-hiding .driver-popover {
          opacity: 0 !important;
          pointer-events: none !important;
          transition: none !important;
        }

        body.tour-hiding .driver-active-element {
          outline: none !important;
          transition: none !important;
        }

        /* Use GPU acceleration for smoother transitions */
        .driver-popover {
          will-change: opacity, transform;
          transform: translateZ(0);
        }

        /* Optimize highlight animations */
        .driver-active-element {
          will-change: auto;
          transform: translateZ(0);
        }
      `;
  document.head.appendChild(style);
}
